/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AttachmentAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import InApp from './InApp/index'
import No from './No/index'
import React from 'react'
import Sms from './Sms/index'



/** @type {import('Simple/types.js').View} */
export default function AttachmentAction({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let threadTypeValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: threadTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sms'}>
<Sms
  viewPath={`${viewPath}/Sms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}